import React from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { mobile } from "../../utilities/detection";
import { gtmJoinClick, gtmGAEvent } from "../../utilities/gtm";
import { routeCodes } from "../../config/routes";
import { getString } from "../../utilities";
import OptionallyDisplayed from "../global/optionallyDisplayed";
import { variousURLs } from "../../config";
import IXLLogo from "../../../assets/img/ixlLogo.svg";
import { adsSelector, isLoggedInSelector } from "../../redux/slices/loginSlice";

export default function Copyright() {
  const navigate = useNavigate();
  const isLoggedIn = useSelector(isLoggedInSelector);
  const ads = useSelector(adsSelector);

  const currentYear = new Date().getFullYear();
  const loggedStyle = isLoggedIn ? "" : "loggedin";
  const maStyle = ads && mobile ? " mobileFixedPadding" : "";

  return (
    <div className={`footer-copyright ${loggedStyle}${maStyle}`}>
      <OptionallyDisplayed doDisplay={!isLoggedIn}>
        <button
          type="button"
          className="button-flat-color cyan round dimensional text"
          onClick={() => {
            gtmJoinClick(location.pathname, "copyright-button");
            navigate(routeCodes.SUBSCRIBE);
          }}
        >
          {getString("join.6", [], true)}
        </button>
      </OptionallyDisplayed>

      <div className="footer-copyright-text">{getString("copyright", [currentYear])}</div>

      <a
        onClick={() => {
          gtmGAEvent({
            eventCategory: "IXL footer",
            eventAction: "button-click",
            eventLabel: location.pathname,
          });
        }}
        href={`${variousURLs.ixl.base}/?partner=abcya&adGroup=footer&utm_source=abcya.com&utm_medium=partner&utm_campaign=footer`}
        target="_blank"
        rel="noopener noreferrer"
      >
        <img
          src={IXLLogo}
          loading="lazy"
          alt={getString("ixl.title")}
          className="footer-copyright-ixl"
          width="632"
          height="236"
        />
      </a>

      <a href={variousURLs.kidsafe} target="_blank" rel="noopener noreferrer">
        <img
          border="0"
          src={variousURLs.kidsafeImg}
          loading="lazy"
          width="160"
          height="60"
          alt={getString("footer.kidsafe.alt")}
          className="footer-copyright-kidsafe"
        />
      </a>
    </div>
  );
}
